import { STATUS_NAMES } from '../../common/constants';

// STATUS_NAMES is shared with the web apps ("In Progress"); the app shows
// status labels in sentence case ("In progress").
export const getStatusLabel = (status, fallback) => {
	const label = STATUS_NAMES[status];
	if (!label) {
		return fallback;
	}

	return label.charAt(0) + label.slice(1).toLowerCase();
};
